/**
 * Link público de la agenda de un negocio, según dónde esté corriendo el front:
 * bajo el dominio raíz (turnlink.app) cada negocio es un subdominio; en cualquier
 * otro host (localhost, previews de Railway) el slug va en el path. Misma regla
 * que routes.js usa para leer el slug.
 */
export const ROOT_DOMAIN = (process.env.REACT_APP_ROOT_DOMAIN || "turnlink.app").toLowerCase();

export function isOnRootDomain(hostname = window.location.hostname) {
  const h = hostname.toLowerCase();
  return h === ROOT_DOMAIN || h.endsWith(`.${ROOT_DOMAIN}`);
}

export function buildBusinessUrl(slug) {
  if (!slug) return "";
  if (isOnRootDomain()) return `https://${slug}.${ROOT_DOMAIN}`;
  return `${window.location.origin}/${slug}`;
}

/** El mismo link sin protocolo, para mostrarlo como texto (mibarber.turnlink.app / host/slug). */
export function displayBusinessUrl(slug) {
  return buildBusinessUrl(slug).replace(/^https?:\/\//, "");
}
